import { UserData } from './types';

const CODE_RE = /[?&]code=[^&]+/;
const STATE_RE = /[?&]state=[^&]+/;
const ERROR_RE = /[?&]error=[^&]+/;

export const hasAuthParams = (searchParams = window.location.search): boolean =>
  (CODE_RE.test(searchParams) || ERROR_RE.test(searchParams)) &&
  STATE_RE.test(searchParams);

export const defaultUserData: UserData = {
  active: true,
  created_at: '',
  default_payment_method_set: false,
  deleted_at: '',
  email: '',
  first_name: '',
  id: '',
  is_superuser: false,
  last_name: '',
  updated_at: '',
};
